"use client";
import { useEffect } from "react";
import { reportClientError } from "@/lib/tracking";

export default function GlobalError({ error, reset }) {
  useEffect(() => {
    console.error(error);
    // The whole layout broke: report it (2026-10-23).
    reportClientError(error, "layout");
  }, [error]);
  return (
    <html>
      <body>
        <main>
          <h1>Something went wrong</h1>
          <button onClick={() => reset()}>Try again</button>
        </main>
      </body>
    </html>
  );
}
